export const MastercardIcon = ({
  strokeColor = "var(--color-icon-bright)",
  ...props
}: any) => (
  <svg width="26" height="16" viewBox="0 0 26 16" fill="none" {...props}>
    <g id="logos:mastercard" clipPath="url(#clip0_205_6143)">
      <path
        id="Vector"
        d="M9.47461 1.66016H16.4977V13.8702H9.47461V1.66016Z"
        fill="#FF5F00"
      />
      <path
        id="Vector_2"
        d="M9.92154 7.76611C9.92154 5.28531 11.1255 3.08486 12.9759 1.66104C11.616 0.625581 9.8993 0 8.02648 0C3.58952 0 0 3.47313 0 7.76611C0 12.059 3.58952 15.5322 8.02638 15.5322C9.89919 15.5322 11.6159 14.9066 12.9759 13.8711C11.1255 12.4689 9.92154 10.2469 9.92154 7.76611Z"
        fill="#EB001B"
      />
      <path
        id="Vector_3"
        d="M25.974 7.76611C25.974 12.059 22.3845 15.5322 17.9476 15.5322C16.0748 15.5322 14.3581 14.9066 12.998 13.8711C14.8709 12.4474 16.0525 10.2469 16.0525 7.76611C16.0525 5.28531 14.8485 3.08486 12.998 1.66104C14.358 0.625581 16.0748 0 17.9476 0C22.3845 0 25.9741 3.49474 25.9741 7.76611H25.974Z"
        fill="#F79E1B"
      />
    </g>
    <defs>
      <clipPath id="clip0_205_6143">
        <rect width="26" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
